export enum streetTypesEnum {
  STREET = 'street',
  ALLEYWAY = 'alleyway',
  AVENUE = 'avenue',
  SQUARE = 'square',
  PASSAGEWAY = 'passageway',
  RIDE = 'ride',
  ROAD = 'road',
  ROUND = 'round',
}
